export default function Loader({ label = "Loading" }) {
  return (
    <div className="py-24 flex items-center justify-center text-[#6b6b6b]">
      <div className="flex items-center gap-3">
        <span className="w-2 h-2 bg-[#b8975d] animate-pulse rounded-full"></span>
        <span className="eyebrow">{label}</span>
      </div>
    </div>
  );
}
